import type { ReactNode } from 'react'

import classNames from 'clsx'

type PopoverHeaderProps = {
  children: ReactNode
  className?: string
}

const PopoverHeader = ({ children, className }: PopoverHeaderProps) => {
  const classes = classNames('hot-popover__header', className)

  return (
    <div slot='header' className={classes}>
      {children}
    </div>
  )
}

export default PopoverHeader
